var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vue-editor" }, [
    _c(
      "div",
      { staticClass: "editor-control" },
      [
        _vm._l(_vm.iconList, function(item) {
          return _c(
            "Icon",
            {
              key: item.type,
              attrs: {
                name: item.name,
                type: item.type,
                icon: item.icon,
                choose: item.choose
              },
              on: { iconClick: _vm.iconClick }
            },
            [
              item.type === "style"
                ? _c("div", { staticClass: "dropmenu drop-style" }, [
                    _c("ul", [
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick($event, "p", "style")
                              }
                            }
                          },
                          [_c("p", [_vm._v("正文")])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick($event, "pre", "style")
                              }
                            }
                          },
                          [_c("pre", [_vm._v("code")])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick($event, "blockquote", "style")
                              }
                            }
                          },
                          [_c("blockquote", [_vm._v("引用")])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick($event, "h1", "style")
                              }
                            }
                          },
                          [_c("h1", [_vm._v("标题一")])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick($event, "h2", "style")
                              }
                            }
                          },
                          [_c("h2", [_vm._v("标题二")])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick($event, "h3", "style")
                              }
                            }
                          },
                          [_c("h3", [_vm._v("标题三 ")])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick($event, "h4", "style")
                              }
                            }
                          },
                          [_c("h4", [_vm._v("标题四 ")])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick($event, "h5", "style")
                              }
                            }
                          },
                          [_c("h5", [_vm._v("标题五 ")])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick($event, "h6", "style")
                              }
                            }
                          },
                          [_c("h6", [_vm._v("标题六")])]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.type === "alignjustify"
                ? _c("div", { staticClass: "dropmenu drop-align" }, [
                    _c("ul", [
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick(
                                  $event,
                                  "justifyCenter",
                                  "alignjustify"
                                )
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-aligncenter"
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("居中")])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick(
                                  $event,
                                  "justifyLeft",
                                  "alignjustify"
                                )
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "iconfont icon-alignleft" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("左对齐")])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick(
                                  $event,
                                  "justifyRight",
                                  "alignjustify"
                                )
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-alignright"
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("右对齐")])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick(
                                  $event,
                                  "justifyFull",
                                  "alignjustify"
                                )
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-alignjustify"
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("默认对齐")])
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.type === "image"
                ? _c("div", { staticClass: "dropmenu drop-image" }, [
                    _c("ul", [
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick($event, "onlineImg", "image")
                              }
                            }
                          },
                          [_c("span", [_vm._v("在线链接")])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.iconClick($event, "localImg", "image")
                              }
                            }
                          },
                          [_c("span", [_vm._v("本地图片")])]
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          )
        }),
        _vm._v(" "),
        _c("button", { on: { click: _vm.doSave } }, [_vm._v("保存")])
      ],
      2
    ),
    _vm._v(" "),
    _c("div", {
      ref: "editor",
      staticClass: "editor-body",
      attrs: { id: "NO1", contenteditable: "true", spellcheck: "false" },
      domProps: { innerHTML: _vm._s(_vm.html) },
      on: {
        change: _vm.doChange,
        keyup: function($event) {
          _vm.changeEditor($event, "mouse")
        },
        mouseup: function($event) {
          _vm.changeEditor($event, "key")
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "upload" }, [_c("upload")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-570be2c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-570be2c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/utils/vue-editor.vue
// module id = null
// module chunks = 